import * as React from "react";
import styles from "./faq.module.scss";
export class FAQComponent extends React.PureComponent<
  { faq?: Array<string | Record<string, string>>; style?: string },
  {}
> {
  get getFaq() {
    return this.props.faq;
  }
  public render() {
    return (
      <ul className={`${styles.faq} ${this.props.style || ""}`}>
        {this.getFaq.map((faq, idx) => {
          const withTitle = typeof faq !== "string";
          const text = withTitle ? (faq as any).description : faq;
          return (
            <li key={idx}>
              <div className={styles.rounded}>{idx + 1}</div>
              {typeof faq !== "string" ? <h2>{(faq as any).title}</h2> : null}
              <p dangerouslySetInnerHTML={{ __html: text }} />
            </li>
          );
        })}
      </ul>
    );
  }
}
